import Header from "../components/Header";
import { MdOutlineShield } from "react-icons/md";
import { HiOutlineLightningBolt } from "react-icons/hi";
import { FaRegCreditCard } from "react-icons/fa";
import { FaCar, FaUser, FaPhoneAlt } from "react-icons/fa";
import { BsSend } from "react-icons/bs";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { id_firebase } from "../content-site";
import { firestore } from "../firebase-config";
import { collection, doc, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { validarCPF } from "../utils/verificaCpf";
import { Card, CardContent } from "../components/ui/Card";
import { ClipboardCheck, ThumbsUp, FileSignature } from "lucide-react";

export default function Financiamento() {
    const [revenda, setRevenda] = useState([]);
    const [enviado, setEnviado] = useState(false);
    const [msgEnviado, setMsgEnviado] = useState('');
    const [nomeMae, setNomeMae] = useState('');
    const [cpf, setCpf] = useState('');
    const [nome, setNome] = useState('');
    const [dataNascimento, setDataNascimento] = useState('');
    const [telefone, setTelefone] = useState('');
    const [email, setEmail] = useState('');
    const [cidade, setCidade] = useState('');
    const [cidadeUf, setCidadeUf] = useState('');
    const [dadosFinanciamento, setDadosFinanciamento] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);

        import("firebase/firestore").then(({ getDoc }) => {
            const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
            getDoc(revendaRef).then((docSnap) => {
                if (docSnap.exists()) {
                    setRevenda(docSnap.data());
                }
            });
        });

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });
        });

        return () => unsubscribe();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!validateForm()) return;
        setEnviado(true);
        setMsgEnviado('Enviando mensagem...');

        let mensagem = `<strong>Dados do financiamento:</strong><br><br>${dadosFinanciamento}`;
        mensagem += `<br><br><strong>Dados pessoais</strong><br>`;
        mensagem += `<br>CPF: ${cpf}`;
        mensagem += `<br>Nome: ${nome}`;
        mensagem += `<br>Data de nascimento: ${dataNascimento}`;
        mensagem += `<br>Telefone: ${telefone}`;
        mensagem += `<br>Email: ${email}`;
        mensagem += `<br>Nome da mãe: ${nomeMae}`;
        mensagem += `<br>Cidade: ${cidade}-${cidadeUf}`;

        fetch('https://us-central1-intermedio-1513801146022.cloudfunctions.net/enviarEmail', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                remetente: `Contato ${revenda.penome_fantasia}<${revenda.peemail}>`,
                assunto: `Simulação de Financiamento - Site ${revenda.penome_fantasia}`,
                destinatarios: revenda.peemail,
                corpo: mensagem,
                corpoHtml: mensagem,
            }),
        })
            .then((res) => {
                setMsgEnviado('E-Mail enviado com sucesso, em breve você receberá um retorno da nossa equipe.');
                setTimeout(() => setEnviado(false), 5000);
                resetForm();
            })
            .catch((error) => {
                setMsgEnviado('Erro ao enviar e-mail, tentar novamente mais tarde');
                setTimeout(() => setEnviado(false), 5000);
                console.error('Erro ao enviar e-mail:', error);
            });
    };

    const resetForm = () => {
        setDadosFinanciamento('');
        setCpf('');
        setNome('');
        setDataNascimento('');
        setTelefone('');
        setEmail('');
        setNomeMae('');
        setCidade('');
        setCidadeUf('');
    };

    const validateForm = () => {
        const newErrors = {};
        if (!dadosFinanciamento.trim()) newErrors.dadosFinanciamento = "Descreva o veículo.";
        if (!cpf.trim() || !validarCPF(cpf)) newErrors.cpf = "CPF inválido.";
        if (!nome.trim()) newErrors.nome = "Nome obrigatório.";
        if (!dataNascimento) newErrors.dataNascimento = "Data de nascimento obrigatória.";
        if (!telefone.trim()) newErrors.telefone = "Telefone obrigatório.";
        if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) newErrors.email = "E-mail inválido.";
        if (!nomeMae.trim()) newErrors.nomeMae = "Nome da mãe obrigatório.";
        if (!cidade.trim()) newErrors.cidade = "Cidade obrigatória.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className="bg-zinc-900">
            <Header />

            <div className="relative h-[300px] md:h-[350px] w-full mt-16 md:mt-20">
                <img
                    src="/banner.png"
                    alt="Banner Malta Automóveis"
                    className="object-cover w-full h-full"
                />

                <div className="absolute inset-0 bg-black/50" />

                <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-2 md:px-4 z-10">
                    <h1 className="text-2xl md:text-6xl font-bold mt-20">Solicite uma simulação de financiamento</h1>
                    <p className="text-base md:text-lg font-semibold mt-2">Envie seus dados para simularmos um financiamento. Em breve retornaremos o contato.</p>
                </div>
            </div>

            <div className="mb-16">
                <h2 className="text-3xl font-bold text-center mb-8 mt-4 text-white">Como Funciona</h2>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 h-[300px] w-10/12 mx-auto">
                    <Card className="border-2 relative h-full bg-black border-orange-500">
                        <CardContent className="p-6 text-center flex flex-col items-center justify-center h-full text-white">
                            <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-xl">
                                1
                            </div>
                            <ClipboardCheck className="text-orange-500 mx-auto mb-3" size={40} />
                            <h3 className="font-bold mb-2">Envio de Interesse</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                Entre em contato pelo email informando o veículo desejado.
                            </p>
                        </CardContent>
                    </Card>

                    <Card className="border-2 relative h-full bg-black border-orange-500">
                        <CardContent className="p-6 text-center flex flex-col items-center justify-center h-full text-white">
                            <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-xl">
                                2
                            </div>
                            <ThumbsUp className="text-orange-500 mx-auto mb-3" size={40} />
                            <h3 className="font-bold mb-2">Simulação</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                Nossa equipe analisa os dados e realiza a simulação de financiamento.
                            </p>
                        </CardContent>
                    </Card>

                    <Card className="border-2 relative h-full bg-black border-orange-500">
                        <CardContent className="p-6 text-center flex flex-col items-center justify-center h-full text-white">
                            <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-xl">
                                3
                            </div>
                            <FileSignature className="text-orange-500 mx-auto mb-3" size={40} />
                            <h3 className="font-bold mb-2">Retorno</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                Retornamos com as melhores condições disponíveis para você.
                            </p>
                        </CardContent>
                    </Card>

                    <Card className="border-2 relative h-full bg-black border-orange-500">
                        <CardContent className="p-6 text-center flex flex-col items-center justify-center h-full text-white">
                            <div className="w-12 h-12 bg-orange-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-xl">
                                4
                            </div>
                            <FaCar className="text-orange-500 mx-auto mb-3" size={40} />
                            <h3 className="font-bold mb-2">Conclusão</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                Finalizamos a negociação e orientamos sobre documentos e retirada do veículo.
                            </p>
                        </CardContent>
                    </Card>

                </div>
            </div>

            <div className="flex flex-col justify-center items-center py-6 md:py-10 mt-10 md:mt-20 min-h-screen">
                <form onSubmit={handleSubmit} className="w-full max-w-lg md:max-w-3xl mx-auto p-4 md:p-6 bg-white rounded-lg shadow">

                    <div className="mb-8">
                        <div className="flex items-center gap-2 text-orange-800 font-bold text-base md:text-lg mb-2">
                            <div className="bg-orange-200 p-2 rounded-lg">
                                <FaCar className="text-xl md:text-2xl" />
                            </div>
                            <h2>VEÍCULO DE INTERESSE</h2>
                        </div>
                        <textarea
                            placeholder="Descreva detalhadamente o veículo desejado (marca, modelo, ano), valor estimado, condições de financiamento (entrada, número de parcelas), possibilidade de troca, etc."
                            className={`w-full border ${errors.dadosFinanciamento ? 'border-orange-500' : 'border-neutral-300'} rounded-lg p-4 text-sm outline-none focus:ring-2 focus:ring-orange-500`}
                            rows={4}
                            value={dadosFinanciamento}
                            onChange={e => setDadosFinanciamento(e.target.value)}
                        />
                        {errors.dadosFinanciamento && <span className="text-orange-500 text-xs">{errors.dadosFinanciamento}</span>}
                    </div>

                    <div className="mb-4">
                        <div className="flex items-center gap-2 text-orange-800 font-bold text-base md:text-lg mb-4">
                            <div className="bg-orange-200 p-2 rounded-lg">
                                <FaUser className="text-xl md:text-2xl" />
                            </div>
                            <h2>DADOS PESSOAIS</h2>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            <div className="flex flex-col">
                                <label className="text-sm font-medium mb-1">CPF *</label>
                                <input
                                    type="text"
                                    placeholder="000.000.000-00"
                                    className={`border ${errors.cpf ? 'border-orange-500' : 'border-neutral-300'} rounded-lg p-3 outline-none focus:ring-2 focus:ring-orange-500`}
                                    value={cpf}
                                    onChange={e => setCpf(formatarCPF(e.target.value))}
                                    maxLength={14}
                                />
                                {errors.cpf && <span className="text-orange-500 text-xs">{errors.cpf}</span>}
                            </div>

                            <div className="flex flex-col">
                                <label className="text-sm font-medium mb-1 flex items-center gap-1">
                                    Data de Nascimento *
                                </label>
                                <input
                                    type="date"
                                    className={`border ${errors.dataNascimento ? 'border-orange-500' : 'border-neutral-300'} rounded-lg p-3 outline-none focus:ring-2 focus:ring-orange-500`}
                                    value={dataNascimento}
                                    onChange={e => setDataNascimento(e.target.value)}
                                />
                                {errors.dataNascimento && <span className="text-orange-500 text-xs">{errors.dataNascimento}</span>}
                            </div>
                        </div>

                        <div className="flex flex-col mb-4">
                            <label className="text-sm font-medium mb-1">Nome Completo *</label>
                            <input
                                type="text"
                                placeholder="Digite seu nome completo"
                                className="border border-neutral-300  rounded-lg p-3 outline-none focus:ring-2 focus:ring-orange-500"
                                value={nome}
                                onChange={e => setNome(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col mb-4">
                            <label className="text-sm font-medium mb-1">
                                Nome Completo da Mãe *
                            </label>
                            <input
                                type="text"
                                placeholder="Digite o nome completo da sua mãe"
                                className="border border-neutral-300  rounded-lg p-3 outline-none focus:ring-2 focus:ring-orange-500"
                                value={nomeMae}
                                onChange={e => setNomeMae(e.target.value)}
                            />
                        </div>

                        <div className="flex flex-col mb-4">
                            <label className="text-sm font-medium mb-1">Cidade *</label>
                            <input
                                type="text"
                                placeholder="Ex: São Paulo - SP"
                                className="border border-neutral-300  rounded-lg p-3 outline-none focus:ring-2 focus:ring-orange-500"
                                value={cidade}
                                onChange={e => setCidade(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="mt-8 md:mt-10">
                        <div className="flex items-center gap-2 text-orange-800 font-bold text-base md:text-lg mb-4">
                            <div className="bg-orange-200 p-2 rounded-lg">
                                <FaPhoneAlt className="text-xl md:text-2xl" />
                            </div>
                            <h2>INFORMAÇÕES DE CONTATO</h2>
                        </div>

                        <div className="flex flex-col md:flex-row gap-4 md:gap-8">
                            <div className="flex flex-col mb-4 flex-1">
                                <label className="text-sm font-medium mb-1">Telefone *</label>
                                <input
                                    type="text"
                                    placeholder="(00) 00000-0000"
                                    className={`border ${errors.telefone ? 'border-orange-500' : 'border-neutral-300'} rounded-lg p-3 outline-none focus:ring-2 focus:ring-orange-500`}
                                    value={telefone}
                                    onChange={e => setTelefone(e.target.value)}
                                />
                                {errors.telefone && <span className="text-orange-500 text-xs">{errors.telefone}</span>}
                            </div>

                            <div className="flex flex-col mb-4 flex-1">
                                <label className="text-sm font-medium mb-1">E-mail *</label>
                                <input
                                    type="email"
                                    placeholder="Digite seu e-mail"
                                    className={`border ${errors.email ? 'border-orange-500' : 'border-neutral-300'} rounded-lg p-3 outline-none focus:ring-2 focus:ring-orange-500`}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                                {errors.email && <span className="text-orange-500 text-xs">{errors.email}</span>}
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="flex items-center justify-center gap-4 text-white bg-[#E94E1B] font-bold text-lg md:text-xl px-8 md:px-20 py-3 md:py-4 rounded-lg mx-auto mt-4 w-full md:w-auto">
                        <BsSend />
                        ENVIAR DADOS
                    </button>
                    {
                        enviado &&
                        <blockquote>
                            <p><em>{msgEnviado}</em></p>
                        </blockquote>
                    }
                </form>
            </div>

            <Footer />
        </div>
    );

    function formatarCPF(valor) {
        valor = valor.replace(/\D/g, "");
        valor = valor.replace(/(\d{3})(\d)/, "$1.$2");
        valor = valor.replace(/(\d{3})(\d)/, "$1.$2");
        valor = valor.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        return valor;
    }
}